import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_RoleAdminSU } from "../shared/data.service";
import { IntListRequest } from "../../services/IntListRequest";

@Component({
	selector: "caass-role-su-user-multiple-schools",
	templateUrl: "./role-su-user-multiple-schools.component.html",
	styleUrls: ["./role-su-user-multiple-schools.component.css"],
})
export class RoleSuUserMultipleSchoolsComponent implements OnInit {
	constructor(private dataService: DataService_RoleAdminSU, private confirmationService: ConfirmationService, private dialogService: DialogService) {}

	ngOnInit(): void {
		this.loadUsers();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////

	userpagerows: any = 10;
	userpagefirst: any = 0;

	SelectedUsers: any = [];
	lstUsers: any = [];

	lstPersonTypeDesc: any = [];
	lstUserLevelDesc: any = [];
	lstActiveDesc: any = [];

	UserCols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "FirstName", header: "First Name" },
		{ field: "LastName", header: "Last Name" },
		{ field: "PersonTypeDesc", header: "Staff Type" },
		{ field: "SchoolFullName", header: "Home School" },
		// { field: "UserLevelDesc", header: "User Level" },
		// { field: "ActiveDesc", header: "Active" },
		// { field: "SchoolCount", header: "School Count" },
	];

	LoadingUser: boolean = false;
	Processing: boolean = false;

	errorMessage: string = "";

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////

	loadUsers() {
		this.errorMessage = "";

		this.lstUsers = [];
		this.SelectedUsers = [];
		this.LoadingUser = true;

		var result = this.dataService.RoleAdminSuUserMultiSchoolSelect();
		result.subscribe(
			(response) => {
				this.lstUsers = response;

				//Load Data Filter Lists
				this.lstPersonTypeDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.PersonTypeDesc)));
				this.lstUserLevelDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.UserLevelDesc)));
				this.lstActiveDesc = Array.from(new Set(this.lstUsers.map((item: any) => item.ActiveDesc)));

				this.LoadingUser = false;
			},
			(error) => {
				this.LoadingUser = false;
			}
		);
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////

	onUserRefresh() {
		this.loadUsers();
	}

	onAssignToHomeSchool() {
		this.errorMessage = "";

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select users to remove roles from other schools";
			return;
		}

		this.confirmationService.confirm({
			key: "UserMultipleSchoolsConfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"This will make all of a user's roles be at their home school only " +
				"(based on the staff member they are assigned). Note: this will remove " +
				"users from their user groups and assign schools and roles manually. " +
				"This WON'T WORK with SBT on the DC server. Are you sure you want to assign " +
				this.SelectedUsers.length +
				" user" +
				(this.SelectedUsers.length == 1 ? "" : "s") +
				" to their home school and unassign them from other schools?",
			header: "Confirm Assign to Home School Only",
			icon: "fa",
			accept: () => {
				this.onFinishAssignToHomeSchool();
			},
		});
	}

	onFinishAssignToHomeSchool() {
		this.Processing = true;

		var lstUID = this.SelectedUsers.map((item) => item.UserID);

		var parms: IntListRequest = {
			lstIDs: lstUID,
		};

		var result = this.dataService.RoleAdminSuAssignToHomeSchoolOnly(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "UserMultipleSchools",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Users were reassigned to their home school only.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadUsers();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "UserMultipleSchools",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign users to their home school only: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onExport() {
		var DataStr: string = "";

		//
		// Add Headers
		//

		DataStr += `"Username",`;
		DataStr += `"Staff ID",`;
		DataStr += `"First Name",`;
		DataStr += `"Last Name",`;
		DataStr += `"Staff Type",`;
		DataStr += `"Home School",`;
		DataStr += `"User Level",`;
		DataStr += `"Active",`;
		DataStr += `"# of Schools"`;
		DataStr += "\n";

		//
		// Add Data
		//
		for (var z = 0; z < this.lstUsers.length; z++) {
			var next = this.lstUsers[z];

			DataStr += `"` + next.UserName + `",`;
			DataStr += `"` + next.StaffID + `",`;
			DataStr += `"` + next.FirstName + `",`;
			DataStr += `"` + next.LastName + `",`;
			DataStr += `"` + next.PersonTypeDesc + `",`;
			DataStr += `"` + next.SchoolFullName + `",`;
			DataStr += `"` + next.UserLevelDesc + `",`;
			DataStr += `"` + next.ActiveDesc + `",`;
			DataStr += `"` + next.SchoolCount + `"`;
			DataStr += "\n";
		}

		var a = document.createElement("a"); //Create <a>

		var FileName = "UserMultipleSchools";

		//
		// Sometimes has issue with plain text, so convert to B64
		//
		DataStr = btoa(DataStr);
		a.href = "data:text/csv;base64," + DataStr;
		a.download = FileName + ".csv";

		a.click(); //Downloaded file
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////

	onUserRowSelect(val) {
		this.errorMessage = "";
	}

	onUserRowUnselect(val) {
		this.errorMessage = "";
	}

	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingUser == true || this.Processing == true;
	}
	////////////////////////////////////////////////
}
